import React, { useContext, useEffect, useState } from 'react';
import { UserProfileContext } from '../../../context/userProfileContext';
import TimeLine from '../timeLine/TimeLine';
import MainData from './MainData';
import './taxReturn.scss';
import { createTaxReturn } from '../../../utils/api/taxReturn';

const TaxReturn = () => {
    const { profileContextData } = useContext(UserProfileContext);
    const { client } = profileContextData;

    const handleCreateRound = async (reason: string) => {
        try {
            await createTaxReturn(client._id, reason);
        } catch (err: any) {
            if (err.status === 402) {
                window.alert('Client is not eligible for tax return');
                err.isHandled = true;
            }
            throw err;
        }
    };

    return (
        <div className={`tax-return regular-modules ${profileContextData.expandClientData ? 'data-expanded' : ''}`}>
            <div className={'timeline-row-wrapper not-active-module'}>
                <TimeLine onCreateRound={handleCreateRound} />
            </div>
            {profileContextData.currentRound ? <MainData /> : null}
        </div>
    );
};

export default TaxReturn;
